<template>
  <div class="container-fluid footer-contact-icon padding-sm" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)">
    <div class="row">
      <div class="icon-box col-xs-12 col-sm-4">
        <div class="icon-box--left">
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
            <g id="CarbonToolKit" opacity="0.849">
              <path id="Path_2107" data-name="Path 2107" d="M8.914,24.5l4.257-4.257-1.414-1.414L7.5,23.086l-.793-.793a1,1,0,0,0-1.414,0l-4,4a1,1,0,0,0,0,1.414l3,3a1,1,0,0,0,1.414,0l4-4a1,1,0,0,0,0-1.414ZM5,28.586,3.414,27,6,24.414,7.586,26Z" transform="translate(-1 -2)" fill="#f1f1f1"></path>
              <path id="Path_2108" data-name="Path 2108" d="M24,30a6.007,6.007,0,0,1-6-6,5.84,5.84,0,0,1,.21-1.547L9.548,13.79A5.848,5.848,0,0,1,8,14,5.976,5.976,0,0,1,2.423,5.816l.558-1.421L6.293,7.707a1.023,1.023,0,0,0,1.414,0,1,1,0,0,0,0-1.414L4.393,2.979l1.423-.557A5.977,5.977,0,0,1,14,8a5.84,5.84,0,0,1-.21,1.547l8.663,8.663A5.855,5.855,0,0,1,24,18a5.976,5.976,0,0,1,5.577,8.184L29.02,27.6l-3.313-3.312a1.023,1.023,0,0,0-1.413,0,1,1,0,0,0,0,1.414l3.313,3.313-1.422.558A5.96,5.96,0,0,1,24,30M10.063,11.476l10.46,10.462-.239.609a3.975,3.975,0,0,0,3.466,5.445l-.871-.87a3,3,0,0,1,0-4.243,3.072,3.072,0,0,1,4.243,0l.87.871a3.976,3.976,0,0,0-5.446-3.466l-.609.239-10.46-10.46.24-.61A3.976,3.976,0,0,0,8.25,4.008l.87.87a3,3,0,0,1,0,4.243,3.072,3.072,0,0,1-4.243,0l-.87-.871a3.975,3.975,0,0,0,5.445,3.466Z" transform="translate(-1 -2)" fill="#f1f1f1"></path>
              <path id="Path_2109" data-name="Path 2109" d="M29.123,2.85a3.072,3.072,0,0,0-4.243,0L17.4,10.33l1.414,1.414,7.48-7.48a1.024,1.024,0,0,1,1.414,0,1,1,0,0,1,0,1.414l-7.48,7.48,1.414,1.415,7.48-7.48a3,3,0,0,0,0-4.243" transform="translate(-1 -2)" fill="#f1f1f1"></path>
            </g>
          </svg>
        </div>
        <div class="icon-box--right">
          <h5 class="weight-light">
            Ready to get back on the road?
          </h5>
          <a href="#" class="sokal-link sokal-link-primary light-theme">
            <span class="sokal-link-copy">Schedule Service</span>
            <svg data-brand-allow="infiniti" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M1 7.39878H13.5M13.5 7.39878L7.5 1M13.5 7.39878L7.5 13.7976" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </a>
        </div>
      </div>
      <div class="icon-box col-xs-12 col-sm-4">
        <div class="icon-box--left">
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
            <path id="BxSupport_1_" data-name="BxSupport (1)" d="M16.5,2A14.516,14.516,0,0,0,2,16.5v6.007A2.805,2.805,0,0,0,4.9,25.2H6.35A1.45,1.45,0,0,0,7.8,23.75V16.293a1.45,1.45,0,0,0-1.45-1.45H5.033a11.583,11.583,0,0,1,22.933,0H26.65a1.45,1.45,0,0,0-1.45,1.45V25.2a2.9,2.9,0,0,1-2.9,2.9H19.4V26.65H13.6V31h8.7a5.806,5.806,0,0,0,5.8-5.8A2.805,2.805,0,0,0,31,22.507V16.5A14.516,14.516,0,0,0,16.5,2" transform="translate(-2 -2)" fill="#f1f1f1" opacity="0.848"></path>
          </svg>
        </div>
        <div class="icon-box--right">
          <h5 class="weight-light">
            Need help? We're here for you!
          </h5>
          <a href="#" class="sokal-link sokal-link-primary light-theme">
            <span class="sokal-link-copy">Contact Us</span>
            <svg data-brand-allow="infiniti" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M1 7.39878H13.5M13.5 7.39878L7.5 1M13.5 7.39878L7.5 13.7976" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </a>
        </div>
      </div>
      <div class="icon-box col-xs-12 col-sm-4">
        <div class="icon-box--left">
          <svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
            <g id="BxCompass" opacity="0.852">
              <path id="Path_2110" data-name="Path 2110" d="M16.5,2A14.5,14.5,0,1,0,31,16.5,14.516,14.516,0,0,0,16.5,2m0,26.1A11.6,11.6,0,1,1,28.1,16.5,11.614,11.614,0,0,1,16.5,28.1" transform="translate(-2 -2)" fill="#f1f1f1"></path>
              <path id="Path_2111" data-name="Path 2111" d="M8,19.6l8.687-2.9L19.6,8l-8.7,2.9Z" transform="translate(0.7 0.7)" fill="#f1f1f1"></path>
            </g>
          </svg>
        </div>
        <div class="icon-box--right">
          <h5 class="weight-light">
            Looking to visit our store?
          </h5>
          <a href="#" class="sokal-link sokal-link-primary light-theme">
            <span class="sokal-link-copy">Get Directions</span>
            <svg data-brand-allow="infiniti" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
              <path d="M1 7.39878H13.5M13.5 7.39878L7.5 1M13.5 7.39878L7.5 13.7976" stroke="black" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  
export default {
  data() {
    return {
      brand: this.$store.state.chosenBrand,
    }
  },
  computed: {
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .footer-contact-icon.padding-sm {
    padding-top: 4%;
    padding-bottom: 4%;
  }
  .footer-contact-icon {
    background: #f5f5f5;
  }
  .footer-contact-icon[data-brand="ford"],
  .footer-contact-icon[data-brand="honda"],
  .footer-contact-icon[data-brand="hyundai"],
  .footer-contact-icon[data-brand="infiniti"],
  .footer-contact-icon[data-brand="kia"],
  .footer-contact-icon[data-brand="lincoln"],
  .footer-contact-icon[data-brand="mitsubishi"],
  .footer-contact-icon[data-brand="nissan"],
  .footer-contact-icon[data-brand="toyota"] {
    background: var(--secondary-light);
  }

  .footer-contact-icon {
    color: var(--primary-dark);
  }
  .footer-contact-icon .icon-box svg path {
    fill: var(--primary-dark);
  }
  .footer-contact-icon .icon-box {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    column-gap: 25px;
  }
  .footer-contact-icon .icon-box .sokal-link-primary.light-theme {
    width: fit-content;
    display: block;
    color: var(--primary-dark);
    text-decoration: none;
    text-transform: uppercase;
  }
  .footer-contact-icon .sokal-link-copy {
    position: relative;
  }
  .footer-contact-icon .sokal-link-copy::after {
    content: "";
    display: block;
    width: 100%;
    border-bottom: 1px solid;
    position: relative;
    bottom: -3px;
    left: 0;
    box-sizing: border-box;
  }

  /* INFINITI STYLES */
  .footer-contact-icon[data-brand="infiniti"] .icon-box--right h5 {
    font-family: var(--heading-text, sans-serif) !important;
  }
  .footer-contact-icon[data-brand="infiniti"] .icon-box .sokal-link-primary {
    text-transform: capitalize;
  }
  .footer-contact-icon[data-brand="infiniti"] .sokal-link-copy {
    font-size: 12px;
  }
  .footer-contact-icon[data-brand="infiniti"] .sokal-link-copy::after {
    width: 0;
    transition: width ease-in-out .1s;
  }
  .footer-contact-icon[data-brand="infiniti"] .sokal-link:hover .sokal-link-copy::after {
    width: 100%;
  }
  .footer-contact-icon[data-brand="infiniti"] .sokal-link-primary {
    display: flex !important;
    gap: 10px;
  }
  .sokal-link svg {
    display: none;
  }

  .footer-contact-icon[data-brand="infiniti"] svg[data-brand-allow="infiniti"] {
      display: inline;
  }

  @media screen and (min-width: 768px) and (max-width: 991px) {
    .footer-contact-icon .icon-box--right h5 {
      width: 85%;
      margin-right: auto;
    }
  }
  @media screen and (max-width: 767px) {
    .footer-contact-icon .icon-box--right h5 {
      width: 230px;
    }
    .footer-contact-icon .icon-box {
      padding-bottom: 25px;
    }
  }
</style>
